<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12">
      <div class="card shadow-lg">
        <div class="card-header bg-primary text-white text-center">
          <h3>{{ isEditMode ? 'Edit Service Area' : 'Create Service Area' }}</h3>
        </div>
        <div class="card-body">
          <form [formGroup]="serviceAreaForm" (ngSubmit)="saveServiceArea()">

            <fieldset readOnlyIfNoGroupPermissionDirective>
            <div class="mb-3">
              <label for="name" class="form-label">Name</label>
              <input 
                type="text" 
                id="name" 
                class="form-control" 
                formControlName="name" 
                required 
                placeholder="Enter the service area name"
                appAutoFocus
              />
            </div>

            </fieldset>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-center mt-4">
              <button type="submit" class="btn btn-primary me-2" readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false">
                {{ isEditMode ? 'Save Changes' : 'Create Service Area' }}
              </button>
              <button type="button" class="btn btn-secondary" routerLink="/service-areas">Cancel</button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
